import { useFormik } from 'formik';
import { useEffect } from 'react';
import { Form } from 'react-bootstrap';
import useGetCategoriesList from '@hooks/INV/useGetCategoriesList';
import { useAppDispatch, useAppSelector } from '@store/hooks';
import { useNavigate, useParams } from 'react-router-dom';
import useGetUnitsOfMeasureList from '@hooks/INV/useGetUnitsOfMeasureList';
import useLookupGetItemType from '@hooks/Lookups/use-Lookup-GetItemType';
import { GetMasterItemsById, cleanUpMasterItemsById, UpdatMasterItems } from '@store/INV/MasterItems/MasterItemsSlice';
import { useTranslation } from 'react-i18next';
import CustomAlert from '@components/Shared/Alert/CustomAlert';
import { MasterItemsSchema } from '../../../../ValidationForm/validationSchema';
import { CardBody } from '@components/card/card';
import Loading from '@components/Shared/Loader/Loading';
import useGetBrandList from '@hooks/INV/Brand/useGetBrandList';
import { usePermissions } from '@Helper/Permisstions/usePermissions';
import useLookupGetExpenseDistribute from '@hooks/Lookups/use-Lookup-GetExpenseDistribute';

const Update = () => {
  const { HasPermission } = usePermissions();
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const { CategoriesList } = useGetCategoriesList();
  const dispatch = useAppDispatch();
  const { ItemId } = useParams();
  const { UnitsOfMeasureList } = useGetUnitsOfMeasureList();
  const { ITEM_TYPE } = useLookupGetItemType();
    // const { ExpenseDistribute, loading: loading5 } = useLookupGetExpenseDistribute();
  
  const { BrandListOptions, loading: loading4 } = useGetBrandList();

  useEffect(() => {
    if (ItemId) {
      dispatch(GetMasterItemsById(ItemId));
    }
    return () => {
      dispatch(cleanUpMasterItemsById());
    };
  }, [ItemId]);

  const { MasterItemsById, loading, error } = useAppSelector(a => a.MasterItemsINV);

  const formik = useFormik({
    initialValues: {
      id: MasterItemsById ? MasterItemsById.id : null,
      itemCode: MasterItemsById ? MasterItemsById.itemCode : '',
      barcode: MasterItemsById ? MasterItemsById.barcode : '',
      name: MasterItemsById ? MasterItemsById.name : '',
      name2: MasterItemsById ? MasterItemsById.name2 : '',
      categoryId: MasterItemsById ? MasterItemsById.categoryId : '',
      // typeId: MasterItemsById ? MasterItemsById.typeId : "",

      displayName: MasterItemsById ? MasterItemsById.displayName : '',
      displayName2: MasterItemsById ? MasterItemsById.displayName2 : '',
      itemType: MasterItemsById ? MasterItemsById.itemType : '',
      serviceItemFlag: MasterItemsById ? MasterItemsById.serviceItemFlag : false,
      isActive: MasterItemsById ? MasterItemsById.isActive : false,
      purchasingEnabledFlag: MasterItemsById ? MasterItemsById.purchasingEnabledFlag : false,
      customerOrderEnabledFlag: MasterItemsById ? MasterItemsById.customerOrderEnabledFlag : false,
      internalOrderEnabledFlag: MasterItemsById ? MasterItemsById.internalOrderEnabledFlag : false,
      soTransactionsFlag: MasterItemsById ? MasterItemsById.soTransactionsFlag : false,
      invTransactionsEnabledFlag: MasterItemsById ? MasterItemsById.invTransactionsEnabledFlag : false,
      salesPrice: MasterItemsById ? MasterItemsById.salesPrice : '',
      purchasePrice: MasterItemsById ? MasterItemsById.purchasePrice : '',
      unitOfMeasure: MasterItemsById ? MasterItemsById.unitOfMeasure : '',
      image: MasterItemsById ? MasterItemsById.image : '',
      demandTimeUp: MasterItemsById ? MasterItemsById.demandTimeUp : '',
      demandTimeDown: MasterItemsById ? MasterItemsById.demandTimeDown : '',
      description: MasterItemsById ? MasterItemsById.description : '',
      discountRate: MasterItemsById ? MasterItemsById.discountRate : '',
      authorizeNegativeStock: MasterItemsById ? MasterItemsById.authorizeNegativeStock : false,
      brandId: MasterItemsById ? MasterItemsById.brandId : '',
      expenseDistribute: MasterItemsById ? MasterItemsById.expenseDistribute : ''
    },
    enableReinitialize: true,
    validationSchema: MasterItemsSchema(t),
    onSubmit: values => {
      dispatch(
        UpdatMasterItems({
          id: values.id,
          itemCode: values.itemCode,
          barcode: values.barcode,
          name: values.name,
          name2: values.name2,
          categoryId: values.categoryId,
          brandId: values.brandId,
          itemType: values.itemType,
          serviceItemFlag: values.serviceItemFlag,
          isActive: values.isActive,
          purchasingEnabledFlag: values.purchasingEnabledFlag,
          customerOrderEnabledFlag: values.customerOrderEnabledFlag,
          internalOrderEnabledFlag: values.internalOrderEnabledFlag,
          soTransactionsFlag: values.soTransactionsFlag,
          invTransactionsEnabledFlag: values.invTransactionsEnabledFlag,
          salesPrice: values.salesPrice,
          purchasePrice: values.purchasePrice,
          unitOfMeasure: values.unitOfMeasure,
          image: values.image,
          demandTimeUp: values.demandTimeUp,
          demandTimeDown: values.demandTimeDown,
          description: values.description,
          discountRate: values.discountRate,
          authorizeNegativeStock: values.authorizeNegativeStock,

          displayName: values.displayName,
          displayName2: values.displayName2,
          expenseDistribute: values.expenseDistribute,
          imagee: null
        })
      )
        .unwrap()
        .then(res => {
          if (res.succeeded === true) {
            formik.resetForm();
            CustomAlert({ action: 'Edit' });
            formik.setSubmitting(false);
          } else {
            formik.setSubmitting(false);
            CustomAlert({ action: 'Error' });
          }
        })
        .catch(error => {
          formik.setSubmitting(false);
          CustomAlert({ action: 'Error' });
        });
    }
  });

  return (
    <>
      <Loading loading={loading} error={error}>
        <Form onSubmit={formik.handleSubmit}>
          <div className='row'>
            <div className='col-xl-9'>
              <div className='row'>
                <div className='col-xl-4'>
                  <div className='form-group mb-3'>
                    <label className='form-label'>{t('LocalName')}</label>
                    <Form.Control
                      className='form-control '
                      type='text'
                      autoComplete='off'
                      name='name2'
                      onChange={formik.handleChange}
                      value={formik.values.name2 || ''}
                      isInvalid={!!(formik.touched.name2 && formik.errors.name2)}
                    />
                    <Form.Control.Feedback type='invalid'>{formik.errors.name2}</Form.Control.Feedback>
                  </div>
                </div>

                <div className='col-xl-4'>
                  <div className='form-group mb-3'>
                    <label className='form-label'>{t('GlobalName')}</label>
                    <Form.Control
                      className='form-control '
                      type='text'
                      autoComplete='off'
                      name='name'
                      onChange={formik.handleChange}
                      value={formik.values.name || ''}
                      isInvalid={!!(formik.touched.name && formik.errors.name)}
                    />
                    <Form.Control.Feedback type='invalid'>{formik.errors.name}</Form.Control.Feedback>
                  </div>
                </div>

                <div className='col-xl-4'>
                  <div className='form-group mb-3'>
                    <label className='form-label'>{t('Barcode')}</label>
                    <Form.Control
                      className='form-control '
                      type='text'
                      autoComplete='off'
                      name='barcode'
                      onChange={formik.handleChange}
                      value={formik.values.barcode || ''}
                      isInvalid={!!(formik.touched.barcode && formik.errors.barcode)}
                    />
                    <Form.Control.Feedback type='invalid'>{formik.errors.barcode}</Form.Control.Feedback>
                  </div>
                </div>

                <div className='col-xl-4'>
                  <div className='form-group mb-3'>
                    <label className='form-label'>{t('كود الصنف (SKU)')}</label>
                    <Form.Control
                      className='form-control '
                      type='text'
                      autoComplete='off'
                      name='itemCode'
                      onChange={formik.handleChange}
                      value={formik.values.itemCode || ''}
                      isInvalid={!!(formik.touched.itemCode && formik.errors.itemCode)}
                    />
                    <Form.Control.Feedback type='invalid'>{formik.errors.itemCode}</Form.Control.Feedback>
                  </div>
                </div>

                <div className='col-xl-4'>
                  <div className='form-group mb-3'>
                    <label className='form-label'> {t('فئة الصنف')}</label>
                    <Form.Select
                      className='form-select'
                      name='categoryId'
                      onChange={formik.handleChange}
                      value={formik.values.categoryId || ''}
                      isInvalid={!!(formik.touched.categoryId && formik.errors.categoryId)}
                    >
                      <option value=''>{i18n.language === 'ar' ? 'إختر' : 'Choose'}</option>
                      {CategoriesList &&
                        CategoriesList?.map((item, idx) => (
                          <option key={++idx} value={item.id}>
                            {i18n.language === 'en' ? item.name : item.name2}
                          </option>
                        ))}
                    </Form.Select>
                  </div>
                </div>

                <div className='col-xl-4'>
                  <div className='form-group mb-3'>
                    <label className='form-label'> {t('Brand')}</label>
                    <Form.Select
                      className='form-select'
                      name='brandId'
                      onChange={formik.handleChange}
                      value={formik.values.brandId}
                      isInvalid={!!(formik.touched.brandId && formik.errors.brandId)}
                    >
                      <option value=''>{i18n.language === 'ar' ? 'إختر' : 'Choose'}</option>
                      {BrandListOptions &&
                        BrandListOptions?.map((item, idx) => (
                          <option key={++idx} value={item.value}>
                            {item.label}
                          </option>
                        ))}
                    </Form.Select>
                    <Form.Control.Feedback type='invalid'>{formik.errors.brandId}</Form.Control.Feedback>
                  </div>
                </div>

                <div className='col-xl-4'>
                  <div className='form-group mb-3'>
                    <label className='form-label'>{t('نوع الصنف')}</label>
                    <Form.Select
                      className='form-select'
                      name='itemType'
                      onChange={formik.handleChange}
                      value={formik.values.itemType || ''}
                      isInvalid={!!(formik.touched.itemType && formik.errors.itemType)}
                    >
                      <option value=''>{i18n.language === 'ar' ? 'إختر' : 'Choose'}</option>
                      {ITEM_TYPE &&
                        ITEM_TYPE?.map((item: any, idx: number) =>
                          item.list?.map((list: any) => (
                            <option key={++idx} value={list.lookupCode}>
                              {i18n.language === 'ar' ? list.meaning2 : list.meaning}
                            </option>
                          ))
                        )}
                    </Form.Select>
                  </div>
                </div>

                <div className='col-xl-4'>
                  <div className='form-group mb-3'>
                    <label className='form-label'>{t('وحدة القياس')}</label>
                    <Form.Select
                      disabled
                      className='form-select'
                      name='unitOfMeasure'
                      onChange={formik.handleChange}
                      value={formik.values.unitOfMeasure || ''}
                      isInvalid={!!(formik.touched.unitOfMeasure && formik.errors.unitOfMeasure)}
                    >
                      <option value=''>{i18n.language === 'ar' ? 'إختر' : 'Choose'}</option>
                      {UnitsOfMeasureList &&
                        UnitsOfMeasureList?.map((item, idx) => (
                          <option key={++idx} value={item.id}>
                            {i18n.language === 'en' ? item.name : item.name2}
                          </option>
                        ))}
                    </Form.Select>
                  </div>
                </div>

                <div className='col-xl-4'>
                  <div className='form-group mb-3'>
                    <label className='form-label'>{t('سعر البيع')}</label>
                    <Form.Control
                      className='form-control '
                      type='text'
                      autoComplete='off'
                      name='salesPrice'
                      onChange={formik.handleChange}
                      value={formik.values.salesPrice || ''}
                      isInvalid={!!(formik.touched.salesPrice && formik.errors.salesPrice)}
                    />
                    <Form.Control.Feedback type='invalid'>{formik.errors.salesPrice}</Form.Control.Feedback>
                  </div>
                </div>

                <div className='col-xl-4'>
                  <div className='form-group mb-3'>
                    <label className='form-label'>{t('سعر الشراء')}</label>
                    <Form.Control
                      className='form-control '
                      type='text'
                      autoComplete='off'
                      name='purchasePrice'
                      onChange={formik.handleChange}
                      value={formik.values.purchasePrice || ''}
                      isInvalid={!!(formik.touched.purchasePrice && formik.errors.purchasePrice)}
                    />
                    <Form.Control.Feedback type='invalid'>{formik.errors.purchasePrice}</Form.Control.Feedback>
                  </div>
                </div>

                <div className='col-xl-4'>
                  <div className='form-group mb-3'>
                    <label className='form-label'>{t('معدل الخصم')}</label>
                    <Form.Control
                      className='form-control '
                      type='text'
                      autoComplete='off'
                      name='discountRate'
                      onChange={formik.handleChange}
                      value={formik.values.discountRate || ''}
                      isInvalid={!!(formik.touched.discountRate && formik.errors.discountRate)}
                    />
                    <Form.Control.Feedback type='invalid'>{formik.errors.discountRate}</Form.Control.Feedback>
                  </div>
                </div>

                <div className='col-xl-4'>
                  <div className='form-group mb-3'>
                    <label className='form-label'>{t('حد الطلب الأعلى')}</label>
                    <Form.Control
                      className='form-control '
                      type='text'
                      autoComplete='off'
                      name='demandTimeUp'
                      onChange={formik.handleChange}
                      value={formik.values.demandTimeUp || ''}
                      isInvalid={!!(formik.touched.demandTimeUp && formik.errors.demandTimeUp)}
                    />
                    <Form.Control.Feedback type='invalid'>{formik.errors.demandTimeUp}</Form.Control.Feedback>
                  </div>
                </div>

                <div className='col-xl-4'>
                  <div className='form-group mb-3'>
                    <label className='form-label'>{t('حد الطلب الأدنى')}</label>
                    <Form.Control
                      className='form-control '
                      type='text'
                      autoComplete='off'
                      name='demandTimeDown'
                      onChange={formik.handleChange}
                      value={formik.values.demandTimeDown || ''}
                      isInvalid={!!(formik.touched.demandTimeDown && formik.errors.demandTimeDown)}
                    />
                    <Form.Control.Feedback type='invalid'>{formik.errors.demandTimeDown}</Form.Control.Feedback>
                  </div>
                </div>

                <div className='col-xl-4'>
                  <div className='form-group mb-3'>
                    <label className='form-label'>{t('Note')}</label>
                    <Form.Control
                      className='form-control '
                      type='text'
                      autoComplete='off'
                      name='description'
                      onChange={formik.handleChange}
                      value={formik.values.description || ''}
                      isInvalid={!!(formik.touched.description && formik.errors.description)}
                    />
                    <Form.Control.Feedback type='invalid'>{formik.errors.description}</Form.Control.Feedback>
                  </div>
                </div>

                {(formik.values.soTransactionsFlag || formik.values.customerOrderEnabledFlag) && (
                  <>
                    <div className='col-xl-4'>
                      <div className='form-group mb-3'>
                        <label className='form-label'>{t('الأسم المحلي للعرض بالفاتورة')}</label>
                        <Form.Control
                          autoComplete='off'
                          className='form-control '
                          type='text'
                          name='displayName2'
                          onChange={formik.handleChange}
                          value={formik.values.displayName2 || ''}
                          isInvalid={!!(formik.touched.displayName2 && formik.errors.displayName2)}
                        />
                        <Form.Control.Feedback type='invalid'>{formik.errors.displayName2}</Form.Control.Feedback>
                      </div>
                    </div>
                    <div className='col-xl-4'>
                      <div className='form-group mb-3'>
                        <label className='form-label'>{t('الأسم العالمي للعرض بالفاتورة')}</label>
                        <Form.Control
                          autoComplete='off'
                          className='form-control '
                          type='text'
                          name='displayName'
                          onChange={formik.handleChange}
                          value={formik.values.displayName || ''}
                          isInvalid={!!(formik.touched.displayName && formik.errors.displayName)}
                        />
                        <Form.Control.Feedback type='invalid'>{formik.errors.displayName}</Form.Control.Feedback>
                      </div>
                    </div>
                  </>
                )}
              </div>
            </div>

            <div className='col-xl-3'>
              <CardBody>
                <div className='p-3 bg-white bg-opacity-10 '>
                  <div className='form-group mb-0'>
                    <div className='shipping-container'>
                      <div className='row align-items-center'>
                        <div className='col-6 pt-1 pb-1'>{t('Active')}</div>
                        <div className='col-6 d-flex align-items-center'>
                          <div className='form-check form-switch ms-auto'>
                            <input
                              type='checkbox'
                              className='form-check-input'
                              name='isActive'
                              checked={formik.values.isActive || false}
                              onChange={formik.handleChange}
                            />
                            <label className='form-check-label' htmlFor='shippingAliExpress'>
                              &nbsp;
                            </label>
                          </div>
                        </div>
                      </div>
                      <hr className='mt-2 mb-2' />
                      <div className='row align-items-center'>
                        <div className='col-6 pt-1 pb-1'>صنف خدمي</div>
                        <div className='col-6 d-flex align-items-center'>
                          <div className='form-check form-switch ms-auto'>
                            <input
                              className='form-check-input'
                              type='checkbox'
                              name='serviceItemFlag'
                              checked={formik.values.serviceItemFlag || false}
                              onChange={formik.handleChange}
                            />
                            <label className='form-check-label' htmlFor='shippingFree'>
                              &nbsp;
                            </label>
                          </div>
                        </div>
                      </div>

                      <hr className='mt-2 mb-2' />
                      <div className='row align-items-center'>
                        <div className='col-6 pt-1 pb-1'>invTransactionsEnabledFlag</div>
                        <div className='col-6 d-flex align-items-center'>
                          <div className='form-check form-switch ms-auto'>
                            <input
                              className='form-check-input'
                              type='checkbox'
                              name='invTransactionsEnabledFlag'
                              checked={formik.values.invTransactionsEnabledFlag || false}
                              onChange={formik.handleChange}
                            />
                            <label className='form-check-label' htmlFor='shippingSunriseWholesale'>
                              &nbsp;
                            </label>
                          </div>
                        </div>
                      </div>
                      <hr className='mt-2 mb-2' />
                      <div className='row align-items-center'>
                        <div className='col-6 pt-1 pb-1'>طلبات العملاء</div>
                        <div className='col-6 d-flex align-items-center'>
                          <div className='form-check form-switch ms-auto'>
                            <input
                              type='checkbox'
                              className='form-check-input'
                              name='customerOrderEnabledFlag'
                              checked={formik.values.customerOrderEnabledFlag || false}
                              onChange={formik.handleChange}
                            />
                            <label className='form-check-label' htmlFor='shippingMegagoods'>
                              &nbsp;
                            </label>
                          </div>
                        </div>
                      </div>

                      <hr className='mt-2 mb-2' />
                      <div className='row align-items-center'>
                        <div className='col-6 pt-1 pb-1'>أوامر البيع</div>
                        <div className='col-6 d-flex align-items-center'>
                          <div className='form-check form-switch ms-auto'>
                            <input
                              type='checkbox'
                              className='form-check-input'
                              name='soTransactionsFlag'
                              checked={formik.values.soTransactionsFlag || false}
                              onChange={formik.handleChange}
                            />
                            <label className='form-check-label' htmlFor='shippingSunriseWholesale'>
                              &nbsp;
                            </label>
                          </div>
                        </div>
                      </div>

                      <hr className='mt-2 mb-2' />
                      <div className='row align-items-center'>
                        <div className='col-6 pt-1 pb-1'>قابل للشراء</div>
                        <div className='col-6 d-flex align-items-center'>
                          <div className='form-check form-switch ms-auto'>
                            <input
                              type='checkbox'
                              className='form-check-input'
                              name='purchasingEnabledFlag'
                              checked={formik.values.purchasingEnabledFlag || false}
                              onChange={formik.handleChange}
                            />
                            <label className='form-check-label' htmlFor='shippingSaleHoo'>
                              &nbsp;
                            </label>
                          </div>
                        </div>
                      </div>

                      <hr className='mt-2 mb-2' />
                      <div className='row align-items-center'>
                        <div className='col-6 pt-1 pb-1'>تحويل داخلي</div>
                        <div className='col-6 d-flex align-items-center'>
                          <div className='form-check form-switch ms-auto'>
                            <input
                              type='checkbox'
                              className='form-check-input'
                              name='internalOrderEnabledFlag'
                              checked={formik.values.internalOrderEnabledFlag || false}
                              onChange={formik.handleChange}
                            />
                            <label className='form-check-label' htmlFor='shippingWholesale2B'>
                              &nbsp;
                            </label>
                          </div>
                        </div>
                      </div>

                      <hr className='mt-2 mb-2' />
                      <div className='row align-items-center'>
                        <div className='col-6 pt-1 pb-1'>سماح البيع بالسالب</div>
                        <div className='col-6 d-flex align-items-center'>
                          <div className='form-check form-switch ms-auto'>
                            <input
                              className='form-check-input'
                              type='checkbox'
                              name='authorizeNegativeStock'
                              checked={formik.values.authorizeNegativeStock || false}
                              onChange={formik.handleChange}
                            />
                            <label className='form-check-label' htmlFor='shippingSunriseWholesale'>
                              &nbsp;
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className='d-flex gap-2 mt-2'></div>
              </CardBody>
            </div>

            <div className='text-center'>
              <div className='d-flex justify-content-between gap-2'>
                {HasPermission('INVEditMasterItems') && (
                  <button
                    disabled={formik.isSubmitting}
                    type='submit'
                    className='btn btn-lg btn-theme mb-1 w-100 rounded-1'
                  >
                    {formik.isSubmitting ? (
                      <div className='spinner-border spinner-border-sm me-2'></div>
                    ) : (
                      <i className='fa fa-save fa-fw me-1'></i>
                    )}
                    {t('Save')}
                  </button>
                )}
                <button
                  type='button'
                  className='btn btn-lg  btn-default mb-1 w-100 rounded-1'
                  onClick={() => navigate('/INV/InventorySettings/MasterItems', { replace: true })}
                >
                  <i className='fa fa-power-off fa-fw me-1'></i> {t('Cancel')}
                </button>
              </div>
            </div>
          </div>
        </Form>
      </Loading>
    </>
  );
};

// const Update = () => {
//   const { HasPermission } = usePermissions();
//   const navigate = useNavigate();
//   const { t, i18n } = useTranslation();
//   const dispatch = useAppDispatch();
//   const { ItemId } = useParams();

//   const { CategoriesList, loading: loading1 } = useGetCategoriesList();
//   const { UnitsOfMeasureList, loading: loading2 } = useGetUnitsOfMeasureList();
//   const { ITEM_TYPE, loading: loading3 } = useLookupGetItemType();
//   const { BrandListOptions, loading: loading4 } = useGetBrandList();
//   const [activeTab, setActiveTab] = useState('basic');

//   useEffect(() => {
//     if (ItemId) {
//       dispatch(GetMasterItemsById(ItemId));
//     }
//     return () => {
//       dispatch(cleanUpMasterItemsById());
//     };
//   }, [ItemId]);

//   const { MasterItemsById, loading, error } = useAppSelector(a => a.MasterItemsINV);

//   const formik = useFormik({
//     initialValues: {
//       id: MasterItemsById ? MasterItemsById.id : null,
//       itemCode: MasterItemsById ? MasterItemsById.itemCode : '',
//       barcode: MasterItemsById ? MasterItemsById.barcode : '',
//       name: MasterItemsById ? MasterItemsById.name : '',
//       name2: MasterItemsById ? MasterItemsById.name2 : '',
//       brandId: MasterItemsById ? MasterItemsById.brandId : '',
//       displayName: MasterItemsById ? MasterItemsById.displayName : '',
//       displayName2: MasterItemsById ? MasterItemsById.displayName2 : '',
//       categoryId: MasterItemsById ? MasterItemsById.categoryId : '',
//       itemType: MasterItemsById ? MasterItemsById.itemType : '',
//       serviceItemFlag: MasterItemsById ? MasterItemsById.serviceItemFlag : false,
//       isActive: MasterItemsById ? MasterItemsById.isActive : true,
//       purchasingEnabledFlag: MasterItemsById ? MasterItemsById.purchasingEnabledFlag : false,
//       customerOrderEnabledFlag: MasterItemsById ? MasterItemsById.customerOrderEnabledFlag : false,
//       internalOrderEnabledFlag: MasterItemsById ? MasterItemsById.internalOrderEnabledFlag : false,
//       soTransactionsFlag: MasterItemsById ? MasterItemsById.soTransactionsFlag : false,
//       invTransactionsEnabledFlag: MasterItemsById ? MasterItemsById.invTransactionsEnabledFlag : false,
//       salesPrice: MasterItemsById ? MasterItemsById.salesPrice : '',
//       purchasePrice: MasterItemsById ? MasterItemsById.purchasePrice : '',
//       unitOfMeasure: MasterItemsById ? MasterItemsById.unitOfMeasure : '',
//       image: MasterItemsById ? MasterItemsById.image : '',
//       demandTimeUp: MasterItemsById ? MasterItemsById.demandTimeUp : '0',
//       demandTimeDown: MasterItemsById ? MasterItemsById.demandTimeDown : '0',
//       description: MasterItemsById ? MasterItemsById.description : '',
//       discountRate: MasterItemsById ? MasterItemsById.discountRate : '0',
//       authorizeNegativeStock: MasterItemsById ? MasterItemsById.authorizeNegativeStock : false
//     },
//     enableReinitialize: true,
//     validationSchema: MasterItemsSchema(t),
//     onSubmit: values => {
//       dispatch(
//         UpdatMasterItems({
//           id: values.id,
//           itemCode: values.itemCode,
//           barcode: values.barcode,
//           name: values.name,
//           name2: values.name2,
//           displayName: values.displayName,
//           displayName2: values.displayName2,
//           categoryId: values.categoryId,
//           brandId: values.brandId || null,
//           itemType: values.itemType,
//           serviceItemFlag: values.serviceItemFlag,
//           isActive: values.isActive,
//           purchasingEnabledFlag: values.purchasingEnabledFlag,
//           customerOrderEnabledFlag: values.customerOrderEnabledFlag,
//           internalOrderEnabledFlag: values.internalOrderEnabledFlag,
//           soTransactionsFlag: values.soTransactionsFlag,
//           invTransactionsEnabledFlag: values.invTransactionsEnabledFlag,
//           salesPrice: values.salesPrice || 0,
//           purchasePrice: values.purchasePrice || 0,
//           unitOfMeasure: values.unitOfMeasure,
//           image: values.image,
//           demandTimeUp: values.demandTimeUp || 0,
//           demandTimeDown: values.demandTimeDown || 0,
//           description: values.description,
//           discountRate: values.discountRate || 0,
//           authorizeNegativeStock: values.authorizeNegativeStock,
//           imagee: null
//         })
//       )
//         .unwrap()
//         .then(res => {
//           if (res.succeeded === true) {
//             formik.resetForm();
//             CustomAlert({ action: 'Edit' });
//             formik.setSubmitting(false);
//           } else {
//             formik.setSubmitting(false);
//             CustomAlert({ action: 'Error' });
//           }
//         })
//         .catch(error => {
//           formik.setSubmitting(false);
//           CustomAlert({ action: 'Error' });
//         });
//     }
//   });

//   return (
//     <>
//       <Loading loading={loading || loading1 || loading2 || loading3 || loading4} error={error}>
//         <Form onSubmit={formik.handleSubmit}>
//           <Card className='mb-0 p-3 shadow-sm'>
//             <div className=''>
//               <h4>
//                 <i className='fas fa-cube me-2 text-theme'></i> {t('EditItem')}
//               </h4>
//               <p className='mb-0'>{t('EditItemDataInInventory')}</p>
//             </div>
//           </Card>

//           <div className='p-3 '>
//             <ul className='nav nav-tabs mb-4' role='tablist'>
//               <li className='nav-item'>
//                 <button
//                   className={`nav-link ${activeTab === 'basic' ? 'active' : ''}`}
//                   onClick={() => setActiveTab('basic')}
//                   type='button'
//                 >
//                   <i className='fas fa-info-circle me-2'></i>
//                   {t('BasicInformation')}
//                 </button>
//               </li>
//               <li className='nav-item'>
//                 <button
//                   className={`nav-link ${activeTab === 'pricing' ? 'active' : ''}`}
//                   onClick={() => setActiveTab('pricing')}
//                   type='button'
//                 >
//                   <i className='fas fa-tag me-2'></i>
//                   {t('Pricing')}
//                 </button>
//               </li>
//               <li className='nav-item'>
//                 <button
//                   className={`nav-link ${activeTab === 'settings' ? 'active' : ''}`}
//                   onClick={() => setActiveTab('settings')}
//                   type='button'
//                 >
//                   <i className='fas fa-cog me-2'></i>
//                   {t('Settings')}
//                 </button>
//               </li>
//             </ul>

//             <div className='row'>
//               <div className='col-xl-9'>
//                 <div className={`tab-pane ${activeTab === 'basic' ? 'show active' : 'd-none'}`}>
//                   <div className='row'>
//                     <div className='col-xl-6'>
//                       <div className='form-group mb-3'>
//                         <label className='form-label required-field'>{t('LocalName')}</label>
//                         <Form.Control
//                           autoComplete='off'
//                           className='form-control'
//                           type='text'
//                           name='name2'
//                           onChange={formik.handleChange}
//                           value={formik.values.name2}
//                           isInvalid={!!(formik.touched.name2 && formik.errors.name2)}
//                           placeholder={t('EnterLocalName')}
//                         />
//                         <Form.Control.Feedback type='invalid'>{formik.errors.name2}</Form.Control.Feedback>
//                       </div>
//                     </div>
//                     <div className='col-xl-6'>
//                       <div className='form-group mb-3'>
//                         <label className='form-label required-field'>{t('GlobalName')}</label>
//                         <Form.Control
//                           autoComplete='off'
//                           className='form-control'
//                           type='text'
//                           name='name'
//                           onChange={formik.handleChange}
//                           value={formik.values.name}
//                           isInvalid={!!(formik.touched.name && formik.errors.name)}
//                           placeholder={t('EnterGlobalName')}
//                         />
//                         <Form.Control.Feedback type='invalid'>{formik.errors.name}</Form.Control.Feedback>
//                       </div>
//                     </div>

//                     <div className='col-xl-6'>
//                       <div className='form-group mb-3'>
//                         <label className='form-label'>{t('Barcode')}</label>
//                         <Form.Control
//                           autoComplete='off'
//                           className='form-control'
//                           type='text'
//                           name='barcode'
//                           onChange={formik.handleChange}
//                           value={formik.values.barcode}
//                           isInvalid={!!(formik.touched.barcode && formik.errors.barcode)}
//                           placeholder={t('EnterBarcode')}
//                         />
//                         <Form.Control.Feedback type='invalid'>{formik.errors.barcode}</Form.Control.Feedback>
//                       </div>
//                     </div>

//                     <div className='col-xl-6'>
//                       <div className='form-group mb-3'>
//                         <label className='form-label required-field'>{t('ItemCode')}</label>
//                         <Form.Control
//                           autoComplete='off'
//                           className='form-control'
//                           type='text'
//                           name='itemCode'
//                           onChange={formik.handleChange}
//                           value={formik.values.itemCode}
//                           isInvalid={!!(formik.touched.itemCode && formik.errors.itemCode)}
//                           placeholder={t('EnterItemCode')}
//                         />
//                         <Form.Control.Feedback type='invalid'>{formik.errors.itemCode}</Form.Control.Feedback>
//                       </div>
//                     </div>

//                     <div className='col-xl-6'>
//                       <div className='form-group mb-3'>
//                         <label className='form-label required-field'>{t('ItemCategory')}</label>
//                         <Form.Select
//                           className='form-select'
//                           name='categoryId'
//                           onChange={formik.handleChange}
//                           value={formik.values.categoryId}
//                           isInvalid={!!(formik.touched.categoryId && formik.errors.categoryId)}
//                         >
//                           <option value=''>{i18n.language === 'ar' ? 'إختر' : 'Choose'}</option>
//                           {CategoriesList &&
//                             CategoriesList?.map((item, idx) => (
//                               <option key={++idx} value={item.id}>
//                                 {i18n.language === 'en' ? item.name : item.name2}
//                               </option>
//                             ))}
//                         </Form.Select>
//                         <Form.Control.Feedback type='invalid'>{formik.errors.categoryId}</Form.Control.Feedback>
//                       </div>
//                     </div>

//                     <div className='col-xl-6'>
//                       <div className='form-group mb-3'>
//                         <label className='form-label'>{t('Brand')}</label>
//                         <Form.Select
//                           className='form-select'
//                           name='brandId'
//                           onChange={formik.handleChange}
//                           value={formik.values.brandId}
//                           isInvalid={!!(formik.touched.brandId && formik.errors.brandId)}
//                         >
//                           <option value=''>{i18n.language === 'ar' ? 'إختر' : 'Choose'}</option>
//                           {BrandListOptions &&
//                             BrandListOptions?.map((item, idx) => (
//                               <option key={++idx} value={item.value}>
//                                 {item.label}
//                               </option>
//                             ))}
//                         </Form.Select>
//                         <Form.Control.Feedback type='invalid'>{formik.errors.brandId}</Form.Control.Feedback>
//                       </div>
//                     </div>

//                     <div className='col-xl-6'>
//                       <div className='form-group mb-3'>
//                         <label className='form-label required-field'>{t('ItemType')}</label>
//                         <Form.Select
//                           className='form-select'
//                           name='itemType'
//                           onChange={formik.handleChange}
//                           value={formik.values.itemType}
//                           isInvalid={!!(formik.touched.itemType && formik.errors.itemType)}
//                         >
//                           <option value=''>{i18n.language === 'ar' ? 'إختر' : 'Choose'}</option>
//                           {ITEM_TYPE &&
//                             ITEM_TYPE?.map((item: any, idx: number) =>
//                               item.list?.map((list: any) => (
//                                 <option key={++idx} value={list.lookupCode}>
//                                   {i18n.language === 'ar' ? list.meaning2 : list.meaning}
//                                 </option>
//                               ))
//                             )}
//                         </Form.Select>
//                         <Form.Control.Feedback type='invalid'>{formik.errors.itemType}</Form.Control.Feedback>
//                       </div>
//                     </div>

//                     <div className='col-xl-6'>
//                       <div className='form-group mb-3'>
//                         <label className='form-label required-field'>{t('UnitOfMeasure')}</label>
//                         <Form.Select
//                           className='form-select'
//                           name='unitOfMeasure'
//                           onChange={formik.handleChange}
//                           value={formik.values.unitOfMeasure}
//                           isInvalid={!!(formik.touched.unitOfMeasure && formik.errors.unitOfMeasure)}
//                         >
//                           <option value=''>{i18n.language === 'ar' ? 'إختر' : 'Choose'}</option>
//                           {UnitsOfMeasureList &&
//                             UnitsOfMeasureList?.map((item, idx) => (
//                               <option key={++idx} value={item.id}>
//                                 {i18n.language === 'en' ? item.name : item.name2}
//                               </option>
//                             ))}
//                         </Form.Select>
//                         <Form.Control.Feedback type='invalid'>{formik.errors.unitOfMeasure}</Form.Control.Feedback>
//                       </div>
//                     </div>
//                   </div>
//                 </div>

//                 <div className={`tab-pane ${activeTab === 'pricing' ? 'show active' : 'd-none'}`}>
//                   <div className='row'>
//                     <div className='col-xl-6'>
//                       <div className='form-group mb-3'>
//                         <label className='form-label'>{t('SalesPrice')}</label>
//                         <Form.Control
//                           autoComplete='off'
//                           className='form-control'
//                           type='number'
//                           min='0'
//                           step='0.01'
//                           name='salesPrice'
//                           onChange={formik.handleChange}
//                           value={formik.values.salesPrice}
//                           isInvalid={!!(formik.touched.salesPrice && formik.errors.salesPrice)}
//                         />
//                         <Form.Control.Feedback type='invalid'>{formik.errors.salesPrice}</Form.Control.Feedback>
//                       </div>
//                     </div>
//                     <div className='col-xl-6'>
//                       <div className='form-group mb-3'>
//                         <label className='form-label'>{t('PurchasePrice')}</label>
//                         <Form.Control
//                           autoComplete='off'
//                           className='form-control'
//                           type='number'
//                           min='0'
//                           step='0.01'
//                           name='purchasePrice'
//                           onChange={formik.handleChange}
//                           value={formik.values.purchasePrice}
//                           isInvalid={!!(formik.touched.purchasePrice && formik.errors.purchasePrice)}
//                         />
//                         <Form.Control.Feedback type='invalid'>{formik.errors.purchasePrice}</Form.Control.Feedback>
//                       </div>
//                     </div>
//                     <div className='col-xl-6'>
//                       <div className='form-group mb-3'>
//                         <label className='form-label'>{t('DiscountRate')}</label>
//                         <Form.Control
//                           autoComplete='off'
//                           className='form-control'
//                           type='number'
//                           min='0'
//                           max='100'
//                           step='0.01'
//                           name='discountRate'
//                           onChange={formik.handleChange}
//                           value={formik.values.discountRate}
//                           isInvalid={!!(formik.touched.discountRate && formik.errors.discountRate)}
//                         />
//                         <Form.Control.Feedback type='invalid'>{formik.errors.discountRate}</Form.Control.Feedback>
//                       </div>
//                     </div>
//                     <div className='col-xl-6'>
//                       <div className='form-group mb-3'>
//                         <label className='form-label'>{t('UpperDemandLimit')}</label>
//                         <Form.Control
//                           autoComplete='off'
//                           className='form-control'
//                           type='number'
//                           min='0'
//                           name='demandTimeUp'
//                           onChange={formik.handleChange}
//                           value={formik.values.demandTimeUp}
//                           isInvalid={!!(formik.touched.demandTimeUp && formik.errors.demandTimeUp)}
//                         />
//                         <Form.Control.Feedback type='invalid'>{formik.errors.demandTimeUp}</Form.Control.Feedback>
//                       </div>
//                     </div>
//                     <div className='col-xl-6'>
//                       <div className='form-group mb-3'>
//                         <label className='form-label'>{t('LowerDemandLimit')}</label>
//                         <Form.Control
//                           autoComplete='off'
//                           className='form-control'
//                           type='number'
//                           min='0'
//                           name='demandTimeDown'
//                           onChange={formik.handleChange}
//                           value={formik.values.demandTimeDown}
//                           isInvalid={!!(formik.touched.demandTimeDown && formik.errors.demandTimeDown)}
//                         />
//                         <Form.Control.Feedback type='invalid'>{formik.errors.demandTimeDown}</Form.Control.Feedback>
//                       </div>
//                     </div>
//                   </div>
//                 </div>

//                 <div className={`tab-pane ${activeTab === 'settings' ? 'show active' : 'd-none'}`}>
//                   <div className='row'>
//                     <div className='col-12'>
//                       <div className='form-group mb-3'>
//                         <label className='form-label'>{t('Note')}</label>
//                         <Form.Control
//                           as='textarea'
//                           rows={3}
//                           autoComplete='off'
//                           className='form-control'
//                           name='description'
//                           onChange={formik.handleChange}
//                           value={formik.values.description}
//                           isInvalid={!!(formik.touched.description && formik.errors.description)}
//                         />
//                       </div>
//                     </div>

//                     {(formik.values.soTransactionsFlag || formik.values.customerOrderEnabledFlag) && (
//                       <>
//                         <div className='col-xl-6'>
//                           <div className='form-group mb-3'>
//                             <label className='form-label'>{t('LocalDisplayName')}</label>
//                             <Form.Control
//                               autoComplete='off'
//                               className='form-control'
//                               type='text'
//                               name='displayName2'
//                               onChange={formik.handleChange}
//                               value={formik.values.displayName2}
//                               isInvalid={!!(formik.touched.displayName2 && formik.errors.displayName2)}
//                             />
//                             <Form.Control.Feedback type='invalid'>{formik.errors.displayName2}</Form.Control.Feedback>
//                           </div>
//                         </div>
//                         <div className='col-xl-6'>
//                           <div className='form-group mb-3'>
//                             <label className='form-label'>{t('GlobalDisplayName')}</label>
//                             <Form.Control
//                               autoComplete='off'
//                               className='form-control'
//                               type='text'
//                               name='displayName'
//                               onChange={formik.handleChange}
//                               value={formik.values.displayName}
//                               isInvalid={!!(formik.touched.displayName && formik.errors.displayName)}
//                             />
//                             <Form.Control.Feedback type='invalid'>{formik.errors.displayName}</Form.Control.Feedback>
//                           </div>
//                         </div>
//                       </>
//                     )}
//                   </div>
//                 </div>
//               </div>

//               <div className='col-xl-3'>
//                 <Card>
//                   <div className='card-header bg-light bg-opacity-30'>
//                     <h5 className='mb-0'>
//                       <i className='fas fa-cog me-2'></i> {t('ItemSettings')}
//                     </h5>
//                   </div>
//                   <div className='card-body'>
//                     <div className='settings-container'>
//                       <div className='form-check form-switch'>
//                         <input
//                           type='checkbox'
//                           className='form-check-input'
//                           name='isActive'
//                           checked={formik.values.isActive}
//                           onChange={formik.handleChange}
//                           id='isActiveSwitch'
//                         />
//                         <label className='form-check-label' htmlFor='isActiveSwitch'>
//                           {t('Active')}
//                         </label>
//                       </div>

//                       <div className='form-check form-switch'>
//                         <input
//                           className='form-check-input'
//                           type='checkbox'
//                           name='serviceItemFlag'
//                           checked={formik.values.serviceItemFlag}
//                           onChange={formik.handleChange}
//                           id='serviceItemSwitch'
//                         />
//                         <label className='form-check-label' htmlFor='serviceItemSwitch'>
//                           {t('ServiceItem')}
//                         </label>
//                       </div>

//                       <div className='form-check form-switch'>
//                         <input
//                           className='form-check-input'
//                           type='checkbox'
//                           name='invTransactionsEnabledFlag'
//                           checked={formik.values.invTransactionsEnabledFlag}
//                           onChange={formik.handleChange}
//                           id='trackInventorySwitch'
//                         />
//                         <label className='form-check-label' htmlFor='trackInventorySwitch'>
//                           {t('TrackInventory')}
//                         </label>
//                       </div>

//                       <div className='form-check form-switch'>
//                         <input
//                           type='checkbox'
//                           className='form-check-input'
//                           name='customerOrderEnabledFlag'
//                           checked={formik.values.customerOrderEnabledFlag}
//                           onChange={formik.handleChange}
//                           id='customerOrdersSwitch'
//                         />
//                         <label className='form-check-label' htmlFor='customerOrdersSwitch'>
//                           {t('EnableCustomerOrders')}
//                         </label>
//                       </div>

//                       <div className='form-check form-switch'>
//                         <input
//                           type='checkbox'
//                           className='form-check-input'
//                           name='soTransactionsFlag'
//                           checked={formik.values.soTransactionsFlag}
//                           onChange={formik.handleChange}
//                           id='salesOrdersSwitch'
//                         />
//                         <label className='form-check-label' htmlFor='salesOrdersSwitch'>
//                           {t('AvailableForSale')}
//                         </label>
//                       </div>

//                       <div className='form-check form-switch'>
//                         <input
//                           type='checkbox'
//                           className='form-check-input'
//                           name='purchasingEnabledFlag'
//                           checked={formik.values.purchasingEnabledFlag}
//                           onChange={formik.handleChange}
//                           id='purchasingSwitch'
//                         />
//                         <label className='form-check-label' htmlFor='purchasingSwitch'>
//                           {t('EnablePurchasing')}
//                         </label>
//                       </div>

//                       <div className='form-check form-switch'>
//                         <input
//                           type='checkbox'
//                           className='form-check-input'
//                           name='internalOrderEnabledFlag'
//                           checked={formik.values.internalOrderEnabledFlag}
//                           onChange={formik.handleChange}
//                           id='internalOrdersSwitch'
//                         />
//                         <label className='form-check-label' htmlFor='internalOrdersSwitch'>
//                           {t('InternalTransfer')}
//                         </label>
//                       </div>

//                       <div className='form-check form-switch'>
//                         <input
//                           className='form-check-input'
//                           type='checkbox'
//                           name='authorizeNegativeStock'
//                           checked={formik.values.authorizeNegativeStock}
//                           onChange={formik.handleChange}
//                           id='negativeStockSwitch'
//                         />
//                         <label className='form-check-label' htmlFor='negativeStockSwitch'>
//                           {t('AllowNegativeStock')}
//                         </label>
//                       </div>
//                     </div>
//                   </div>
//                 </Card>
//               </div>
//             </div>

//             <div className='d-flex justify-content-between mt-4'>
//               <div>
//                 {activeTab !== 'basic' && (
//                   <button
//                     type='button'
//                     className='btn btn-secondary'
//                     onClick={() => setActiveTab(activeTab === 'pricing' ? 'basic' : 'pricing')}
//                   >
//                     <i className='fas fa-arrow-left me-2'></i>
//                     {activeTab === 'pricing' ? t('BackToBasic') : t('BackToPricing')}
//                   </button>
//                 )}
//               </div>

//               <div className='d-flex gap-2'>
//                 <button
//                   type='button'
//                   className='btn btn-default'
//                   onClick={() => navigate('/INV/InventorySettings/MasterItems', { replace: true })}
//                 >
//                   <i className='fas fa-times me-2'></i>
//                   {t('Cancel')}
//                 </button>

//                 {activeTab !== 'settings' && (
//                   <button
//                     type='button'
//                     className='btn btn-primary'
//                     onClick={() => setActiveTab(activeTab === 'basic' ? 'pricing' : 'settings')}
//                   >
//                     {activeTab === 'basic' ? t('ContinueToPricing') : t('ContinueToSettings')}
//                     <i className='fas fa-arrow-right ms-2'></i>
//                   </button>
//                 )}

//                 {activeTab === 'settings' && (
//                   <button disabled={formik.isSubmitting} type='submit' className='btn btn-success'>
//                     {formik.isSubmitting ? (
//                       <>
//                         <div className='spinner-border spinner-border-sm me-2'></div>
//                         {t('Updating')}
//                       </>
//                     ) : (
//                       <>
//                         <i className='fas fa-save me-2'></i>
//                         {t('UpdateItem')}
//                       </>
//                     )}
//                   </button>
//                 )}
//               </div>
//             </div>
//           </div>
//         </Form>
//       </Loading>
//     </>
//   );
// };

export default Update;
